module.exports = __webpack_public_path__ + "img/img115.2623f7cc.svg";